// src/api.js
import axios from 'axios';

// Base URL for the backend API - change this when deploying to production
// export const API_BASE_URL = 'http://localhost:8000';
export const API_BASE_URL = 'https://api.kobithangarments.com';

// Admin panel URL
export const ADMIN_URL = `${API_BASE_URL}/admin`;

// Storage URL for images
export const STORAGE_URL = `${API_BASE_URL}/storage`;

/**
 * Get the full image URL from a storage path
 * @param {string} imagePath - The image path (can be a full URL or storage path)
 * @returns {string} The full image URL
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath;
  return `${STORAGE_URL}/${imagePath}`;
};

const api = axios.create({
  baseURL: API_BASE_URL,
  // You can add default headers here if needed, e.g. Authorization
  // headers: { Authorization: 'Bearer TOKEN' },
});

export default api;
